<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">Share event</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <copy-link
        :dropdown-options="shareOptions"
        :link="selectedUrl"
        style="margin-bottom: 1.5rem"
        @update:selected-url="selectedUrl = $event"
      />
      <div class="buttons-wrapper">
        <div class="social-buttons">
          <a
            class="social-button"
            :href="`mailto:contact@core-event.co?subject=${eventTitle}&body=${selectedUrl}`"
          >
            <v-icon color="primary">email</v-icon>
          </a>
          <a
            class="social-button"
            target="_blank"
            :href="`https://www.facebook.com/share.php?u=${selectedUrl}`"
          >
            <img src="/assets/socials/facebook.svg" alt="facebook">
          </a>
          <a
            class="social-button"
            target="_blank"
            :href="`https://www.linkedin.com/shareArticle?&url=${selectedUrl}`"
          >
            <img src="/assets/socials/linkedin.svg" alt="linkedin">
          </a>
          <a
            class="social-button"
            target="_blank"
            :href="`https://twitter.com/intent/tweet?url=${selectedUrl}`"
          >
            <img src="/assets/socials/x.svg" alt="x">
          </a>
        </div>
        <main-button outline @click="onViewEventPageClick">
          <v-icon style="margin-right: 0.5rem">open_in_new</v-icon>
          view event page
        </main-button>
      </div>
    </div>
  </div>
</template>
<script>
import CopyLink from '@/components/shared/copy-link.vue'

export default {
  name: 'share-event-modal',
  components: { CopyLink },
  props: {
    shareOptions: {
      type: Array,
      default: () => [],
    },
    eventTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedUrl: this.shareOptions.length ? this.shareOptions[0].url : '',
    }
  },
  methods: {
    onViewEventPageClick() {
      window.open(this.selectedUrl,'_blank')
    },
  },
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 34rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
.title-close {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.buttons-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.social-buttons {
  display: flex;
}
.social-button {
  display: flex;
  width: 3rem;
  height: 3rem;
  padding: 0.75rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 1.5rem;
  background: #FFF;
}

.social-button:hover {
  background: #E6F1F8;
}
</style>

